import React, { useState, useMemo } from 'react';
import { Form, Formik } from 'formik';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import FormSelect from '../../../components/dropdown/formSelect';
import {
    useWealthlaneCustomerApi,
    useGetCustomerUserForSandbox,
    useGetSandboxSharedUsers,
} from '../../../hooks';
import { toast } from 'react-toastify';
import ToastComponent from '../../../components/toast';
import { useQueryClient } from 'react-query';
import * as Yup from 'yup';
import Heading from '../../../components/typography';
import { COLORS } from '../../../constants/style/color';
import { SandboxService } from '@wealthlane/api-services/wealthlane-identity-service';

interface ShareSandboxModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    rowData: any;
    domId?: string;
}

const SHARE_SANDBOX_VALIDATION = Yup.object().shape({
    sandboxId: Yup.array()
        .min(1, 'Please select at least one user')
        .required('Please select at least one user'),
});

const ShareSandboxModal = ({
    isModalOpen,
    closeModal,
    rowData,
    domId,
}: ShareSandboxModalProps): JSX.Element => {
    const { handleRequest } = useWealthlaneCustomerApi();
    const queryClient = useQueryClient();
    const [loading, setLoading] = useState<boolean>(false);

    const { data: userOptions, isLoading: isLoadingUsers } =
        useGetCustomerUserForSandbox(handleRequest);

    const { data: sharedUserIds, isLoading: isLoadingSharedUsers } =
        useGetSandboxSharedUsers(handleRequest, rowData?.id);

    const initialValues = useMemo(() => {
        return {
            sandboxId: sharedUserIds ?? [],
        };
    }, [sharedUserIds]);

    const handleSubmit = (values: any): void => {
        setLoading(true);

        handleRequest(SandboxService.postApiIdentityApiSandboxShare(rowData?.id, values.sandboxId))
            .then((data: any) => {
                if (data) {
                    toast.success(
                        <ToastComponent
                            label='Success'
                            message={data.message}
                            id='successToast'
                        />
                    );
                    queryClient.invalidateQueries('getSwitchSandboxList');
                    closeModal();
                }
            })
            .catch((error: any) => {
                console.log('error', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={SHARE_SANDBOX_VALIDATION}
            onSubmit={(values) => {
                handleSubmit(values);
            }}>
            {({ touched, handleChange, errors, setFieldValue, values }) => {
                return (
                    <ModalComponent
                        show={isModalOpen}
                        closeModal={closeModal}
                        size='sm'
                        title='Share Sandbox'
                        id={domId}>
                        <Form id='shareSandboxForm'>
                            <ModalBodyComponent id='modalBody'>
                                {/* <div className='mb-4'>
                                    <Heading
                                        variant='body-s'
                                        title={`Sharing: ${rowData?.name ?? 'Sandbox'}`}
                                        color={COLORS.Gray}
                                        id='sandboxName'
                                    />
                                </div> */}

                                <div className='mb-4'>
                                    <FormSelect
                                        type='text'
                                        label='Select Users'
                                        name='sandboxId'
                                        id='sandboxId'
                                        viewName='sandboxId'
                                        onChange={handleChange}
                                        errors={errors}
                                        touched={touched}
                                        options={userOptions}
                                        isLoading={isLoadingUsers || isLoadingSharedUsers}
                                        values={values.sandboxId}
                                        setFieldValue={setFieldValue}
                                        multiple={true}
                                        placeholder='Search and select users...'
                                        required
                                    />
                                </div>

                                {/* <div>
                                    <FormSelect
                                        type='text'
                                        label='Access Type'
                                        name='accessType'
                                        id='accessType'
                                        viewName='accessType'
                                        onChange={handleChange}
                                        errors={errors}
                                        touched={touched}
                                        options={accessTypeOptions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                        placeholder='Select access type...'
                                        required
                                    />
                                </div> */}

                                {/* <div className='mt-4 p-3 bg-gray-50 rounded-md'>
                                    <Heading
                                        variant='body-xs'
                                        title='Note: Selected users will receive a notification about the shared sandbox.'
                                        color={COLORS.Gray}
                                        id='shareNote'
                                    />
                                </div> */}
                            </ModalBodyComponent>
                            <ModalFooterComponent
                                modalStatus='Add'
                                loading={loading}
                                onCloseModal={() => {
                                    closeModal();
                                }}
                                valueChanged={values.sandboxId.length === 0}
                                id='modalFooter'
                                buttonTitle='Share'
                            />
                        </Form>
                    </ModalComponent>
                );
            }}
        </Formik>
    );
};

export default ShareSandboxModal;

